import { mapQuickStats } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function ResortQuickFacts() {
  return (
    <section aria-labelledby="map-intro-heading" className="bg-secondary/40 py-14 md:py-16">
      <div className="shell">
        <Reveal>
          <Eyebrow>Your Base Camp at a Glance</Eyebrow>
        </Reveal>
        <h2 id="map-intro-heading" className="display-lg mt-6 max-w-[18ch]">
          <MaskReveal>Find the Right Part of</MaskReveal>
          <MaskReveal delay={0.08}>the Resort for Your Stay</MaskReveal>
        </h2>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-muted-foreground">
            Auburn RV Resort offers 71 RV sites in a variety of sizes, including pull-through,
            back-in and accessible options. Use the official Auburn RV Resort map below to
            familiarize yourself with the property and understand the general layout before
            requesting availability.
          </p>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-muted-foreground">
            Site availability and assignments are confirmed directly by Auburn RV Resort staff.
            Viewing the map does not guarantee that a specific site is available.
          </p>
        </Reveal>

        <ul className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {mapQuickStats.map((stat) => (
            <li key={stat.label} className="border-t border-border pt-5">
              <p className="font-display text-3xl tracking-tight md:text-4xl">{stat.value}</p>
              <p className="eyebrow mt-2 text-muted-foreground">{stat.label}</p>
            </li>
          ))}
        </ul>

        <Reveal delay={0.12}>
          <ResortLink variant="solid" href="/accommodations/" className="mt-10 w-full sm:w-auto">
            Explore Accommodations
          </ResortLink>
        </Reveal>
      </div>
    </section>
  );
}
